<template>
	<CCard>
		<CCardHeader>
			<h5>Sélectionner un client</h5>
		</CCardHeader>
		<CCardBody>
			<GTreeView
				:input-name="inputName"
				placeholder="Rechercher un client"
				:multiple="false"
				v-on:update:selected="data => $emit('update:selection', data)"
				:local-data="defaultOptions"
				:value="defaultValue"
				:async="defaultValue === null"
				:disabled="disabled"
				:load-options="loadOptions" />
		</CCardBody>
	</CCard>
</template>

<script>
	import GTreeView from '../ghostlexly-components/GTreeView';

	export default {
		components: { GTreeView },
		props: {
			customer: {
				type: Object,
				default: null,
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			inputName: String,
		},
		computed: {
			defaultValue() {
				if (this.customer === null) {
					return null;
				}

				return this.customer['@id'];
			},
			defaultOptions() {
				if (this.customer === null) {
					return [];
				}

				let name = '';
				if (this.customer.address) {
					name = `${this.customer.email} - ${this.customer.address.firstName} ${this.customer.address.lastName}`;
				} else {
					name = this.customer.email;
				}

				return [
					{
						name: name,
						'@id': this.customer['@id'],
					},
				];
			},
		},
		methods: {
			loadOptions({ action, searchQuery, callback }) {
				if (action === 'ASYNC_SEARCH') {
					let params = new URLSearchParams();
					params.append('role[]', 'ROLE_CUSTOMER');
					params.append('role[]', 'ROLE_GUEST');
					params.append('search_autocomplete', searchQuery);

					this.$axios.get(`/api/users/getAllUsers?${params.toString()}`).then(res => {
						const options = res.data['hydra:member'].map(item => {
							let name = '';
							if (item.address) {
								name = `${item.email} - ${item.address.firstName} ${item.address.lastName}`;
							} else {
								name = item.email;
							}
							return {
								'@id': item.idIri,
								name: name,
							};
						});
						callback(null, options);
					});
				}
			},
		},
	};
</script>
